import mHelper from '../../config/Helper';
var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

class DownloadControllers {
    GET_DOCUMENT_A = (periode, callback) => {
        fetch(mHelper.URL_API() + "document/ad-a", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                periode : periode
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_DOCUMENT_B = (periode, callback) => {
        fetch(mHelper.URL_API() + "document/ad-b", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                periode : periode
            })
        })
        .then((response) =>  response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    
    VIEW_DOC_BAR = (name, callback) => {
        fetch(mHelper.URL_API() + "/files/barrecon", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                names : name
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    VIEW_DOC_BUKPOT = (name, callback) => {
        fetch(mHelper.URL_API() + "/files/bukpot", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                names : name
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    VIEW_DOC_INVOICE = (name, callback) => {
        fetch(mHelper.URL_API() + "/files/invoice-digipos", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                names : name
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    VIEW_DOC_INVOICE_SIGN = (name, callback) => {
        fetch(mHelper.URL_API() + "/files/invoice-sign", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                names : name
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    VIEW_DOC_FAKTUR_PAJAK = (name, callback) => {
        fetch(mHelper.URL_API() + "/files/faktur-pajak-digipos", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                names : name
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }
    
}

const mDownloadControllers = new DownloadControllers();
export default mDownloadControllers;